import React from 'react';
import PropTypes from 'prop-types';
import { CDN_BASE_URL } from '../../../../../../../../../.storybook/utils';
import './image.scss';

const Image = ({
  classNames,
  source,
  asBackground,
  shape,
  size,
  overlaid,
  alt,
}) => {
  if (!source) return null;

  let imagePath = '';
  if (source) {
    imagePath = source.startsWith('https')
      ? source
      : `${CDN_BASE_URL}/${source}`;
    imagePath = `${imagePath}?crop=1:1,smart&width=88&dpr=2`;
  }

  const getClassNames = () => {
    const prefix = 'image--';
    let styles = '';
    if (classNames) styles += classNames;
    if (shape) styles += ' ' + prefix + shape;
    if (overlaid) styles += ' ' + prefix + 'overlaid';
    if (size) styles += ' ' + prefix + size;
    if (asBackground) styles += ' ' + prefix + 'asBackground';

    return styles.trimStart();
  };

  // TODO: To be moved into its own component
  if (asBackground) {
    return (
      <div
        className={getClassNames()}
        style={{
          backgroundImage: `url(${source})`,
          backgroundPosition: 'center',
          backgroundSize: 'auto',
          backgroundRepeat: 'no-repeat',
        }}
      />
    );
  }

  return <img src={imagePath} className={getClassNames()} alt={alt} />;
};

export const ImageSizes = {
  xsmall: 'x-small',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'x-large',
  original: 'original',
};

export const ImageShapes = {
  default: 'original',
  rounded: 'rounded',
  squared: 'squared',
};

Image.propTypes = {
  /** Image URL or path */
  source: PropTypes.string.isRequired,
  /** List of appliable sizes: */
  size: PropTypes.oneOf(Object.values(ImageSizes)),
  /** Arbitrary styles */
  classNames: PropTypes.string,
  /** List of appliable shapes: */
  shape: PropTypes.oneOf(Object.values(ImageShapes)),
  alt: PropTypes.string.isRequired,
  /** If the image should have an overlay: */
  overlaid: PropTypes.bool,
  asBackground: PropTypes.bool,
};

Image.defaultProps = {
  source: null,
  alt: null,
  size: ImageSizes.large,
  shape: ImageShapes.default,
  overlaid: false,
  asBackground: false,
};

export default Image;
